<template>
  <mqtt-status-bar />

  <broker-details />
</template>
